export default {
      id: "ic_arrow_right_gray-usage",
      viewBox: "0 0 11 17",
      url: "/" + "images/icons.3.109.2.svg#ic_arrow_right_gray-usage",
      toString: function () {
        return this.url;
      }
    }